import React from 'react'
import { Contributions, GroupPlanType } from 'Utilities/Plans/ContributionCalculator'
import { TieredRates } from 'Utilities/pharaoh.types'
import { Label } from 'Utilities/config'
import styles from './index.module.scss'
import SupplementalPlan from 'Components/Plans/SupplementalPlan/index.helpers'
import Plan, { PlanBody } from 'Components/Plans/plan-subcomponents/Plan'
import PlanTitle from 'Components/Plans/plan-subcomponents/PlanTitle'
import { Member } from 'Utilities/Hooks/useStargate'
import EETierRate from './EESupplementalSubComp/EETierRate'
import BenefitComp from './EESupplementalSubComp/BenefitComp'
import numeral from 'numeral'
import BenefitAmountContainer from './EESupplementalSubComp/BenefitAmountContainer'
import benefitStyle from './EESupplementalSubComp/EESupplementalSubComp.module.scss'
import { GlobalStringConstant } from 'GlobalStringConstant'
import { PremiumSplits } from 'Components/Plans/plan-subcomponents/Plan.helpers'
import { LifeEEPlan } from '../LifePlan/index.helpers'

interface Props {
  plan: { rate: TieredRates, plan: SupplementalPlan | LifeEEPlan, isRenewal: boolean }
  contributions: Contributions
  selected?: boolean
  label: Label
  selectHandler?(plan: SupplementalPlan | LifeEEPlan): void
  showWeeklyPayments: boolean
  premium?: PremiumSplits
  member: Member
}

const VTLPlanEE: React.FC<Props> = ({ plan, selected, label, selectHandler, contributions, showWeeklyPayments, member }) => {
  const portability = plan.plan.data.portability ? 'You are able to take the policy with you after your employment ends.' : 'You are not able to take the policy with you after your employment ends.'
  const term = plan.plan.data.planTerm
  const sbc = plan.plan.data.sbc

  return <Plan selected={!!selected}>
    <PlanTitle
      id={plan.plan.id}
      planName={plan.plan.name}
      carrier= {plan.plan.carrier}
      selected={selected}
      includesProsperBenefits={false}
      planType={GroupPlanType.life}
      label={label}
      sbc={sbc}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
    />
    <PlanBody noWrap={true}>
      <EETierRate
        plan={plan}
        contributions={contributions}
        showWeeklyPayments={showWeeklyPayments}
        member={member}
        showAfterEmpCont={false}
        onlyIndividual={true}
      />
      <BenefitComp amountLabel='face value' name={GlobalStringConstant[0].benefit_amount} benefitAmount={numeral(plan.plan.data.benefitsIndividual).format('0,0')}/>
      <div className={styles.vertContainer}>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].plan_term}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              { term &&
                <span className={benefitStyle.amount}>{term.slice(0, -1)} term</span>
              }
            </div>
          </div>
        </BenefitAmountContainer>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].portability}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              <span className={benefitStyle.portability_text}>{portability}</span>
            </div>
          </div>
        </BenefitAmountContainer>
      </div>
    </PlanBody>
  </Plan>
}

export default VTLPlanEE
